import { getCompany, getConnector, getTaskAndTaskWorkflow, getUserAndEventTime } from './lib/index.js';
import { WEBHOOK_EVENT_TYPES } from '../webhook-event-types.js';
export const createIncomeSyncedSamplePayload = () => {
    return {
        eventType: WEBHOOK_EVENT_TYPES.INCOME_SYNCED,
        ...getUserAndEventTime(),
        ...getTaskAndTaskWorkflow(),
        data: {
            income: {
                income: 45000,
                incomeType: 'yearly',
                annualIncome: 45000,
                hourlyIncome: 21.56,
                netHourlyRate: 18.44,
                payCycle: 'weekly',
                nextExpectedPayDate: '2020-06-30T12:00:00.000Z',
                currentPayPeriodStart: '2020-06-13T12:00:00.000Z',
                currentPayPeriodEnd: '2020-06-27T12:00:00.000Z',
                unpaidHoursInPayPeriod: 24
            },
            ...getCompany(),
            ...getConnector(),
            linkedAccount: '5f7212103a40e91f95ba376d'
        }
    };
};
//# sourceMappingURL=income-synced.js.map